var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.300704 12.0053C0.300704 11.3902 0.799324 10.8916 1.4144 10.8916H11.9945C12.445 10.8916 12.8511 11.1629 13.0235 11.5791C13.1958 11.9953 13.1006 12.4743 12.7821 12.7928L1.9012 23.6737C1.46628 24.1086 0.761123 24.1086 0.326196 23.6737C-0.108731 23.2387 -0.108732 22.5336 0.326194 22.0987L9.30584 13.119H1.4144C0.799324 13.119 0.300704 12.6204 0.300704 12.0053Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7817 0.325796C13.2168 0.760502 13.2172 1.46566 12.7824 1.9008L1.9016 12.7927C1.4669 13.2278 0.761741 13.2282 0.326594 12.7935C-0.108553 12.3588 -0.10891 11.6536 0.325796 11.2185L11.2066 0.326594C11.6413 -0.108553 12.3465 -0.10891 12.7817 0.325796Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9676 0.0107561C12.5826 0.00771798 13.0837 0.503869 13.0868 1.11894L13.109 5.62948C13.1121 6.24455 12.6159 6.74563 12.0009 6.74866C11.3858 6.7517 10.8847 6.25555 10.8817 5.64048L10.8594 1.12994C10.8564 0.514871 11.3525 0.013794 11.9676 0.0107561Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9416 1.10821C12.9446 1.72329 12.4484 2.22436 11.8334 2.22739L7.33403 2.24954C6.71896 2.25257 6.21789 1.75642 6.21486 1.14134C6.21183 0.526273 6.70799 0.0252029 7.32306 0.0221736L11.8224 1.37983e-05C12.4375 -0.00301553 12.9385 0.493143 12.9416 1.10821Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10818 17.2627C1.72326 17.2597 2.22434 17.7558 2.22739 18.3709L2.24966 22.8701C2.25271 23.4852 1.75656 23.9863 1.14149 23.9893C0.526421 23.9924 0.0253383 23.4962 0.0222927 22.8812L1.39468e-05 18.3819C-0.00303164 17.7668 0.493113 17.2658 1.10818 17.2627Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89412 22.8582C6.89716 23.4733 6.40101 23.9743 5.78594 23.9774L1.27545 23.9997C0.660383 24.0027 0.159304 23.5066 0.156264 22.8915C0.153224 22.2764 0.649373 21.7753 1.26444 21.7723L5.77493 21.75C6.39 21.747 6.89108 22.2431 6.89412 22.8582Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.5f658166066fded7ed8315050bcd001a.svg";
export { ForwardRef as ReactComponent };